import React from 'react';
import { css } from 'emotion';
import CloseIcon from 'client/shared/Icon/components/XIcon';
import { Field, WrappedFieldArrayProps } from 'redux-form';
import { FieldInputWithRedux } from '../../../FieldInput';
import {
  PlusIcon,
  AddOptionButton,
  StyledFieldLabel,
  LabelHelperText,
  OptionsContainer,
  OptionsInputsGridContainer,
  RemoveOptionButton,
} from '../InteractivePoll/styles';

export function OptionsFieldArray({
  fields,
  meta: { submitFailed, error },
}: WrappedFieldArrayProps) {
  return (
    <OptionsContainer>
      <StyledFieldLabel htmlFor="options">Poll choices</StyledFieldLabel>
      <LabelHelperText isError={submitFailed && error}>
        You'll need at least 2 choices and a maximum of 7 to publish a poll.
      </LabelHelperText>
      <OptionsInputsGridContainer>
        <div>
          {fields.map((name: string, index: number) => {
            return (
              <div
                key={`${name}`}
                className={css`
                  margin-bottom: 1.6rem;
                  width: 100%;
                `}
              >
                <Field
                  component={FieldInputWithRedux}
                  placeholder={`Choice ${index + 1}`}
                  name={`${name}.description`}
                  id={`${name}.description`}
                  label={`option #${index + 1}`}
                />
              </div>
            );
          })}
        </div>
        <div>
          {fields.map((name: string, index: number) => {
            const fieldValue = fields.get(index).description;
            return (
              <RemoveOptionButton
                onClick={() => fields.remove(index)}
                type="button"
                aria-label={
                  fieldValue
                    ? `Remove ${fieldValue} option`
                    : 'Remove option row'
                }
                isDisabled={fields.length <= 2}
              >
                <CloseIcon
                  fillColor={fields.length > 2 ? '#C9CBCD' : '#F2F2F3'}
                  strokeWidth={1}
                  className={css`
                    width: 12px;
                    margin-left: 6px;
                  `}
                />
              </RemoveOptionButton>
            );
          })}
        </div>
      </OptionsInputsGridContainer>
      {fields.length < 7 && (
        <AddOptionButton
          onClick={() => fields.push({ description: '' })}
          type="button"
          aria-label="Add new option"
        >
          <PlusIcon /> Add option
        </AddOptionButton>
      )}
    </OptionsContainer>
  );
}
